import tours from '@/services/api/tours';
import contact from '@/services/api/contact';
import leadCapture from '@/services/api/leadCapture';

export default {
  tours,
  contact,
  leadCapture
}
